import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

const STATUS_STYLES = {
  draft: "bg-neutral-100 text-neutral-700",
  pending: "bg-[#FEF7E0] text-[#B98900]",
  approved: "bg-[#E6F4EA] text-[#008060]",
  rejected: "bg-[#FCE8E6] text-[#D82C0D]",
};

export default function StaffHistory() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api
      .get("/timesheets/mine/history")
      .then((r) => setRows(r.data))
      .catch(async () => {
        // Fallback: derive from weekly fetches is heavy; use /timesheets/all only for admin.
        // Use dedicated non-existent endpoint safely.
      });
    // We'll use a fallback: fetch by iterating via a lightweight custom endpoint if not present.
    // Instead, we simply query the mine week list endpoint below.
    api
      .get("/timesheets/mine/list")
      .then((r) => setRows(r.data))
      .catch((e) => {
        // Final fallback: only current-week is visible.
        toast.error(formatApiError(e));
      });
  }, []);

  return (
    <div className="p-6 md:p-10 max-w-[1200px]">
      <div className="text-xs uppercase tracking-widest text-neutral-500 mb-2">History</div>
      <h1 className="font-display font-black text-3xl md:text-5xl leading-none mb-8">
        Past weeks
      </h1>
      <div className="bg-white border border-[#E5E5E5] rounded-md overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#F3F3F2]">
            <tr className="text-left text-xs uppercase tracking-wider text-neutral-500">
              <th className="px-4 py-3">Week</th>
              <th className="px-4 py-3 text-right">Hours</th>
              <th className="px-4 py-3 text-right">Billable</th>
              <th className="px-4 py-3">Status</th>
              <th className="px-4 py-3">Reviewed by</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td colSpan={5} className="px-4 py-6 text-center text-neutral-500">
                  No history yet.
                </td>
              </tr>
            ) : (
              rows.map((r) => (
                <tr key={r.id} className="border-t border-[#E5E5E5]">
                  <td className="px-4 py-3 font-mono-num">{r.week_start}</td>
                  <td className="px-4 py-3 text-right font-mono-num">{r.total_hours}</td>
                  <td className="px-4 py-3 text-right font-mono-num">{r.billable_hours}</td>
                  <td className="px-4 py-3">
                    <span className={`status-pill ${STATUS_STYLES[r.status]}`}>{r.status}</span>
                  </td>
                  <td className="px-4 py-3 text-neutral-600">{r.reviewed_by || "—"}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
